/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { productActionCreators } from "../../services/Actions";
import {
  FiSearch,
  FiChevronRight,
  FiUsers,
  FiCalendar,
} from "react-icons/fi";
import * as moment from "moment";
import Loader from "../../Components/Loader";
import { ToastContainer } from "react-toastify";
import { debounce } from "lodash";
import ReactPaginate from "react-paginate";
import RenderHirePurchasePage from "../RenderHirePurchasePage";

function NonMembers() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetSubmittedOrders } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const product = useSelector((state) => state.product);
  const { orders, isLoading, paginate } = product;
  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    GetSubmittedOrders(true, 1, limit, null, "non_member");
  }, [limit]);

  const handlePageClick = (event) => {
    GetSubmittedOrders(true, event.selected + 1, limit, null, "non_member");
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetSubmittedOrders(
      true,
      1,
      limit,
      val ? `&search=${val}` : null,
      "non_member"
    );
  }, 800);

  const isNonMember = (o) => {
    const t = (o?.user_id?.user_type ?? o?.user_type ?? "")
      .toString()
      .toLowerCase();
    return t === "non_member" || t === "nonmember";
  };
  const nonMemberOrders = (orders || []).filter(isNonMember);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4 md:p-8">
      <RenderHirePurchasePage title={"Non-Member Applications"}>

        <div className="mb-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="relative flex-1 max-w-md">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
              <FiSearch />
            </span>
            <input
              type="search"
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 dark:text-gray-100 leading-5 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition duration-150 ease-in-out"
              placeholder="Search by name or phone..."
              onChange={onSearchTextChange}
            />
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Show:
            </label>
            <select
              className="block w-24 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg border"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >
              {[15, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow-sm rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600 px-6 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            <div className="col-span-5 flex items-center gap-2">
              <FiUsers /> Customer
            </div>
            <div className="col-span-3 flex items-center gap-2">
              <FiUsers /> ID
            </div>
            <div className="col-span-2 flex items-center gap-2">
              <FiCalendar /> Date
            </div>
            <div className="col-span-2 text-right">Action</div>
          </div>

          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            {isLoading ? (
              <div className="py-20 flex justify-center">
                <Loader />
              </div>
            ) : nonMemberOrders?.length > 0 ? (
              nonMemberOrders.map((order, idx) => (
                <div
                  key={order.id || idx}
                  className="grid grid-cols-1 md:grid-cols-12 items-center px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  <div className="col-span-5 flex items-center mb-2 md:mb-0">
                    <img
                      className="h-10 w-10 rounded-full border border-gray-200 object-cover"
                      src={
                        order?.user_id?.profile_image ||
                        `https://ui-avatars.com/api/?name=${encodeURIComponent(
                          order?.user_id?.name || order?.name || "U"
                        )}&size=40&background=fde68a&color=92400e&bold=true`
                      }
                      alt="avatar"
                    />
                    <div className="ml-4">
                      <div className="text-sm font-bold text-gray-900 dark:text-gray-100">
                        {order?.user_id?.name || order?.name}
                      </div>
                      <div className="text-xs text-gray-500 md:hidden">
                        ID: {order?.user_id?.staff_id || order?.staff_id || "—"}
                      </div>
                    </div>
                  </div>

                  <div className="hidden md:block col-span-3">
                    <span className="px-2.5 py-2 rounded-full text-xs font-medium dark:bg-gray-700 dark:text-gray-50 bg-amber-100 text-amber-800">
                      {order?.user_id?.staff_id || order?.staff_id || "—"}
                    </span>
                  </div>

                  <div className="col-span-2 text-sm text-gray-600 dark:text-gray-400 mb-4 md:mb-0">
                    {moment(order?.created_at).format("MMM DD, YYYY")}
                  </div>

                  <div className="col-span-2 md:text-right">
                    <button
                      onClick={() =>
                        history.push({
                          pathname: "/mart/order-detailed",
                          state: order,
                        })
                      }
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-all shadow-sm"
                    >
                      Process
                      <FiChevronRight className="ml-2 -mr-1 h-4 w-4" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="py-20 text-center">
                <p className="text-gray-500 italic">
                  No non-member applications found.
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="mt-8 flex justify-center">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            previousLabel="Prev"
            onPageChange={handlePageClick}
            pageCount={Math.ceil(pageCount / limit)}
            containerClassName="inline-flex items-center -space-x-px shadow-sm rounded-md"
            pageLinkClassName="px-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            previousLinkClassName="px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-l-md text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            nextLinkClassName="px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-r-md text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
            activeLinkClassName="z-10 bg-amber-50 border-amber-500 text-amber-600"
          />
        </div>

        <ToastContainer autoClose={3000} />
      </RenderHirePurchasePage>
    </div>
  );
}

export default NonMembers;
